<template>
  <div>
    <nav-bar ref="form"/>
    <div class="sec-wight-bg py-16 ">
      <div class="container sec-garay-bg border-radius ">
        <div class="row ">
          <h5 class="text-blue col py-0">
            <page-title :titles="'دسته بندی مقالات'"/>
          </h5>
        </div>
      </div>
      <div class="container  " v-if="isPageLoaded">
        <div class="row">
          <div class="col-12 col-md-3 " v-for="item in BlogCategories" :key="item.id">
            <div class="sec-garay-bg border-radius">
              <router-link :to="{path: 'BlogPosts',query:{BlogPosts:item.id}}">
                <p class=" pt-5 text-center third-color p-2">{{ item.title }}</p>
                <v-img :src="$replaceHttps(item.imageUrl)" class="image-size "></v-img>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-menu></footer-menu>
    <v-overlay
        id="searchOverLay"
        :absolute="false"
        :color="'#f7f1fc'"
        :opacity="0.7"
        :value="showLoaderDialog"
        :z-index="6">
      <div class="row h-100 align-items-center justify-content-center">
        <div class="loading-spinner">
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import FooterMenu from "@/components/footer";
import PageTitle from "@/components/titles";

export default {
  name: "BlogCategories",
  components: {PageTitle, FooterMenu, NavBar},
  metaInfo: {
    title: 'ماشین سازان اصلانیان-اخبار و مقالات'
  },
  data: () => ({
    isPageLoaded: false,
    BlogCategories: [],
    showLoaderDialog: false,
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getImgUrl(pic) {
      this.showLoaderDialog = true;
      return require("../assets/img/" + pic);
    },
    getData() {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/BlogCategories", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.isPageLoaded = true
            let json = JSON.parse(result)
            this.showLoaderDialog = false;
            this.BlogCategories = json.filter(x => x.isActive === true)

          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>